import type {WarehouseData} from '../../types';

import {WarningOutlined} from '@ant-design/icons';
import {Divider} from '@ds/components';

import ActionRow from '../common/ActionRow/ActionRow';
import SectionHeader from '../common/SectionHeader/SectionHeader';
import StockLine from './components/StockLine/StockLine';

type WarehouseSectionProps = {
  data: WarehouseData;
  vendorId: string | number;
};

const WarehouseSection: React.FC<WarehouseSectionProps> = ({data, vendorId}) => {
  const ptkCount = data.ptk_product_count ?? 0;

  return (
    <section className="flex flex-col gap-4 px-3.5 pb-5">
      <SectionHeader title="انبار و موجودی" />
      <StockLine
        title="کالاهای پرفروش شما"
        type="atp"
        vendorId={vendorId}
        inStock={data.atp?.available_product_count ?? 0}
        outOfStock={data.atp?.out_of_stock_product_count ?? 0}
      />
      <Divider className="bg-gray-02" size={2} />
      <StockLine
        title="کالاهای نیاز به اصلاح موجودی"
        type="penetration"
        vendorId={vendorId}
        inStock={data.penetration?.available_product_count ?? 0}
        outOfStock={data.penetration?.out_of_stock_product_count ?? 0}
      />
      {ptkCount > 0 && (
        <ActionRow
          title="کالاهای با قیمت غیرمنصفانه"
          navigationUrl="/chortke/unfair-price"
          icon={<WarningOutlined className="text-warning-heavy" aria-hidden />}
          badge={ptkCount <= 10 ? ptkCount : '9+'}
        />
      )}
    </section>
  );
};

export default WarehouseSection;
